import { createTheme, SimplePaletteColorOptions } from '@mui/material/styles';
import { greyBlue, darkBlue } from './colors';
import { ColorPartial } from '@mui/material/styles/createPalette';
import createCache from '@emotion/cache';

//module augmentation to allow custon pallete gtypes
declare module '@mui/material/styles' {
  interface Palette {
    greyBlue: ColorPartial;
    classicPrimary: SimplePaletteColorOptions;
    classicSecondary: SimplePaletteColorOptions;
    neutral: SimplePaletteColorOptions;
    quote: SimplePaletteColorOptions;
    res: SimplePaletteColorOptions;
    primaryLight: SimplePaletteColorOptions;
  }
  interface PaletteOptions {
    greyBlue?: ColorPartial;
    classicPrimary?: SimplePaletteColorOptions;
    classicSecondary?: SimplePaletteColorOptions;
    neutral?: SimplePaletteColorOptions;
    quote?: SimplePaletteColorOptions;
    res?: SimplePaletteColorOptions;
    primaryLight?: SimplePaletteColorOptions;
  }
}
declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    quote: true;
    res: true;
    neutral: true;
    classicPrimary: true;
    classicSecondary: true;
    primaryLight: true;
  }
}

declare module '@mui/material/Checkbox' {
  interface CheckboxPropsColorOverrides {
    quote: true;
    res: true;
    neutral: true;
    classicPrimary: true;
    classicSecondary: true;
    primaryLight: true;
  }
}
declare module '@mui/material/Radio' {
  interface RadioPropsColorOverrides {
    quote: true;
    res: true;
    neutral: true;
    classicPrimary: true;
    classicSecondary: true;
    primaryLight: true;
  }
}

const baseTheme = createTheme();

//get the base them so we can access existing values if required
const theme = createTheme({
  typography: {
    fontFamily: ['Poppins', 'Helvetica', 'Arial', 'sans-serif'].join(','),
    button: {
      //textTransform: 'none'
    }
  },
  palette: {
    secondary: {
      light: '#4D5055',
      main: greyBlue[900],
      dark: '#000000'
    },
    primary: {
      light: '#508EAB',
      main: darkBlue[700],
      dark: '#003750'
    },
    classicPrimary: {
      light: greyBlue[200],
      main: greyBlue[500],
      dark: greyBlue[900],
      contrastText: baseTheme.palette.common.white
    },
    classicSecondary: {
      light: darkBlue[200],
      main: darkBlue[500],
      dark: darkBlue[800],
      contrastText: baseTheme.palette.common.white
    },
    neutral: {
      light: greyBlue[400],
      main: greyBlue[700],
      dark: greyBlue[800],
      contrastText: baseTheme.palette.common.white
    },
    quote: {
      light: '#CCA97A',
      main: '#BB9B6A',
      dark: '#A38661',
      contrastText: baseTheme.palette.common.white
    },
    res: {
      light: '#8045A4',
      main: '#6C3290',
      dark: '#4F2767',
      contrastText: baseTheme.palette.common.white
    },
    primaryLight: {
      light: darkBlue[300],
      main: '#508EAB',
      dark: darkBlue[700],
      contrastText: baseTheme.palette.common.white
    },
    error: {
      light: '#E57373',
      main: '#F44336',
      dark: '#D32F2F'
    },
    warning: {
      light: '#FFB74D',
      main: '#FF9800',
      dark: '#F57C00'
    },
    info: {
      light: '#64B5F6',
      main: '#2196F3',
      dark: '#1976D2'
    },
    success: {
      light: '#81C784',
      main: '#4CAF50',
      dark: '#388E3C'
    },
    background: {
      default: greyBlue[100],
      paper: '#FFFFFF'
    },
    grey: {
      '50': '#FAFAFA',
      '100': '#F5F5F5',
      '200': '#EEEEEE',
      '300': '#E0E0E0',
      '400': '#BDBDBD',
      '500': '#9E9E9E',
      '600': '#757575',
      '700': '#616161',
      '800': '#424242',
      '900': '#212121',
      A100: '#D5D5D5',
      A200: '#AAAAAA',
      A400: '#575757',
      A700: '#303030'
    },
    greyBlue: greyBlue
  }
});

export const primaryTheme = createTheme(theme, {
  components: {
    // Name of the component
    MuiButton: {
      defaultProps: {
        disableElevation: true // No more shadow!
      },
      styleOverrides: {
        sizeSmall: {
          fontWeight: 'initial'
        }
      }
    },
    MuiAppBar: {
      styleOverrides: {
        colorDefault: { backgroundColor: theme.palette.common.white, color: greyBlue[900] },
        colorPrimary: { backgroundColor: theme.palette.secondary.light }
      }
    },
    MuiBreadcrumbs: {
      styleOverrides: {
        separator: {
          color: greyBlue[700]
        },
        li: {
          p: {
            color: greyBlue[600]
          }
        }
      }
    }
  }
});

export function createEmotionCache() {
  return createCache({ key: 'css' });
}
